import { Button, Modal } from "react-bootstrap";
import "./SalesSlip.scss";
import { useRef, useState } from "react";
import { useTranslation } from "react-i18next";

interface ISalesSlipModalBtnProps {
  tid: string;
}
const SalesSlipModalBtn = ({ tid }: ISalesSlipModalBtnProps) => {
  const [showSalesSlip, setShowSalesSlip] = useState<boolean>(false);
  const modalBodyRef = useRef<HTMLDivElement>(null);
  const { t } = useTranslation();
  return (
    <>
      {/* 매출전표 조회 버튼 */}
      <Button
        type="button"
        className="serviceMng-btn btn btn-gray btn-sm"
        onClick={() => setShowSalesSlip((prev) => !prev)}
      >
        매출전표 조회
      </Button>
      <Modal
        show={showSalesSlip}
        backdrop="static"
        className="billStatementModal"
        id="billModal"
        style={{ opacity: 1 }}
      >
        <Modal.Header>
          <Modal.Title style={{ width: "100%" }}>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <h3>매출전표 조회</h3>
              <div className="exit" onClick={() => setShowSalesSlip(false)}>
                <i className="icon_cancel" />
              </div>
            </div>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body ref={modalBodyRef}>
          <div>
            <iframe
              // src={`https://iniweb.inicis.com/receipt/iniReceipt.jsp?noTid=INIAPICARDwrapsobill20240830092000507295`}
              src={`https://iniweb.inicis.com/receipt/iniReceipt.jsp?noTid=${tid}`}
              style={{ height: "100vh" }}
              width="100%"
              // frameborder="0"
            ></iframe>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default SalesSlipModalBtn;
